import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg/Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 128 128"
    }, props), {
        children: /*#__PURE__*/ _jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "51",
            height: "51",
            fill: "none",
            children: [
                /*#__PURE__*/ _jsx("mask", {
                    id: "mask0_1434_5418",
                    style: {
                        maskType: "alpha"
                    },
                    width: "51",
                    height: "51",
                    x: "0",
                    y: "0",
                    maskUnits: "userSpaceOnUse",
                    children: /*#__PURE__*/ _jsx("path", {
                        fill: "#C4C4C4",
                        d: "M0 0H50.075V50.075H0z"
                    })
                }),
                /*#__PURE__*/ _jsxs("g", {
                    mask: "url(#mask0_1434_5418)",
                    children: [
                        /*#__PURE__*/ _jsx("circle", {
                            cx: "24.372",
                            cy: "24.997",
                            r: "16.234",
                            fill: "url(#paint0_linear_1434_5418)"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            fill: "url(#paint1_linear_1434_5418)",
                            d: "M36.618 28.126c.926 2.69-2.484 6.303-7.617 8.071-5.134 1.768-10.046 1.022-10.972-1.667-.927-2.69 2.484-6.303 7.617-8.071 5.133-1.768 10.046-1.022 10.972 1.667z"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            fill: "#1F2337",
                            d: "M28.9 33.81c-2.424 1.768-6.618 2.227-9.368 1.026-1.374-.602-2.128-1.504-2.235-2.477l.15 1.37c.107.973.86 1.877 2.235 2.477 2.75 1.202 6.944.742 9.368-1.027 1.211-.885 1.752-1.929 1.646-2.902l-.15-1.37c.106.972-.434 2.017-1.646 2.902z"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            fill: "#4048FF",
                            d: "M28.311 28.429c1.374.601 2.129 1.504 2.235 2.477.107.973-.433 2.018-1.645 2.902-2.424 1.769-6.618 2.228-9.368 1.027-1.374-.602-2.129-1.504-2.235-2.477-.107-.973.433-2.019 1.646-2.902 2.425-1.77 6.617-2.23 9.367-1.027z"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            fill: "#B5E4FF",
                            d: "M28.048 25.677l-4.188-2.849a.956.956 0 00-.143-.078c-.447-.195-1.127-.12-1.52.167a.841.841 0 00-.123.107l-3.47 3.688c-.582.62-.834 1.29-.764 1.927l.396 3.616c.092.836.739 1.611 1.919 2.127 2.361 1.033 5.961.639 8.043-.881 1.04-.76 1.504-1.657 1.412-2.492l-.396-3.616c-.07-.636-.462-1.238-1.166-1.716z"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            fill: "#B5E4FF",
                            d: "M26.365 16.778c-2.082 1.52-5.682 1.915-8.043.882-1.18-.517-1.827-1.292-1.919-2.127l.397 3.615c.07.636.461 1.238 1.164 1.716l4.188 2.849a.962.962 0 00.143.078c.447.195 1.127.12 1.52-.167a.842.842 0 00.123-.107l3.472-3.688c.582-.62.835-1.29.765-1.928l-.396-3.615c.09.836-.374 1.733-1.414 2.492z"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            fill: "#FFC142",
                            d: "M27.849 17.429l.055.504c.063.573-.178 1.165-.694 1.713l-3.472 3.687a.545.545 0 01-.085.073c-.15.11-.373.188-.61.213a1.3 1.3 0 01-.64-.076.599.599 0 01-.1-.053l-4.186-2.847c-.623-.424-.986-.95-1.049-1.522l-.055-.505c.087.797.704 1.535 1.827 2.026 2.249.984 5.678.608 7.662-.84.992-.722 1.434-1.577 1.347-2.373z"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            fill: "#FFA318",
                            d: "M27.848 17.427c.088.797-.354 1.651-1.345 2.374-1.982 1.448-5.412 1.824-7.662.84-1.123-.491-1.74-1.23-1.827-2.026-.044-.403.048-.821.278-1.23.223-.397.579-.786 1.067-1.144 1.982-1.447 5.412-1.823 7.662-.84.555.244.985.547 1.29.887.312.348.493.736.537 1.14z"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            fill: "#1F2337",
                            d: "M26.92 15.717c-2.425 1.769-6.619 2.228-9.369 1.027-1.374-.602-2.127-1.504-2.234-2.479l.15 1.37c.107.974.86 1.877 2.236 2.478 2.75 1.201 6.944.741 9.367-1.027 1.212-.885 1.753-1.93 1.646-2.903l-.15-1.37c.106.975-.434 2.019-1.647 2.904z"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            fill: "#4048FF",
                            d: "M26.328 10.337c1.375.601 2.129 1.504 2.236 2.477.106.973-.433 2.018-1.646 2.902-2.424 1.769-6.618 2.229-9.368 1.027-1.374-.6-2.127-1.503-2.234-2.477-.107-.975.433-2.019 1.646-2.902 2.424-1.77 6.617-2.229 9.366-1.027z"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            fill: "#B0E1FF",
                            d: "M28.198 33.5c1.04-.76 1.504-1.657 1.412-2.493-.092-.836-.739-1.611-1.919-2.127-2.361-1.033-5.961-.639-8.043.881-1.04.76-1.504 1.657-1.412 2.493.092.836.739 1.61 1.919 2.127 2.36 1.033 5.961.638 8.043-.881z",
                            opacity: "0.5"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            fill: "#B0E1FF",
                            d: "M28 33.414c.993-.724 1.435-1.58 1.347-2.378-.087-.797-.704-1.537-1.83-2.029-2.251-.985-5.687-.608-7.672.84-.992.725-1.435 1.581-1.347 2.379.087.797.704 1.537 1.83 2.03 2.252.984 5.686.607 7.672-.842z",
                            opacity: "0.63"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            fill: "#FFA318",
                            d: "M27.289 26.924a3.624 3.624 0 00-.142-.06l-3.625-1.462-.558.061-3.222 2.213c-.044.03-.086.06-.126.09-.993.724-1.435 1.58-1.348 2.377.088.798.705 1.537 1.83 2.03 2.252.984 5.688.608 7.673-.841.992-.725 1.434-1.58 1.347-2.378-.086-.798-.703-1.538-1.829-2.03z"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            fill: "#FFC142",
                            d: "M27.772 31.33c-1.985 1.449-5.42 1.825-7.672.84-1.126-.492-1.743-1.231-1.83-2.029l.228 2.085c.087.798.704 1.537 1.83 2.03 2.252.984 5.688.608 7.672-.841.993-.725 1.435-1.58 1.348-2.378l-.229-2.085c.087.799-.355 1.653-1.347 2.378zM23.568 25.739c.075-.055.108-.12.101-.179-.006-.06-.052-.116-.137-.153a.654.654 0 00-.569.056c-.084.062-.117.126-.11.186.006.061.053.116.137.153.17.074.43.046.578-.063z"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            fill: "#FFC142",
                            d: "M23.418 23.266l-.816.09.251 2.294.817-.09-.252-2.294z"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("defs", {
                    children: [
                        /*#__PURE__*/ _jsxs("linearGradient", {
                            id: "paint0_linear_1434_5418",
                            x1: "24.372",
                            x2: "24.372",
                            y1: "8.763",
                            y2: "51.338",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ _jsx("stop", {
                                    stopColor: "#00CC9E"
                                }),
                                /*#__PURE__*/ _jsx("stop", {
                                    offset: "1",
                                    stopColor: "#4048FF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("linearGradient", {
                            id: "paint1_linear_1434_5418",
                            x1: "33.983",
                            x2: "23.744",
                            y1: "39.881",
                            y2: "25.68",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ _jsx("stop", {
                                    stopColor: "#1F2337"
                                }),
                                /*#__PURE__*/ _jsx("stop", {
                                    offset: "1",
                                    stopColor: "#1F2337",
                                    stopOpacity: "0"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
export default Icon;
